import { AppConstants } from '../../util/app-constants';

export class PageRequest {
  page: number;
  size: number;

  constructor(page: number, size: number) {
    this.page = page;
    this.size = size;
  }

  static firstPage(): PageRequest {
    return {
      page: 0,
      size: AppConstants.DEFAULT_PAGE_SIZE
    };
  }

  static maxPage(): PageRequest {
    return {
      page: 0,
      size: AppConstants.MAX_PAGE_SIZE
    };
  }
}
